
import Vue from 'vue';
import WarRoomLogoIcon from './assets/war-room-logo.vue.svg';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';
import WarRoomLandingVideo from '~/components/partials/war-room/WarRoomLandingVideo/WarRoomLandingVideo.vue';
import BravadoTheme from '~/components/common/BravadoTheme/BravadoTheme.vue';
import PlayIcon from '~/components/partials/war-room/WarRoomLandingVideo/images/play-button.vue.svg';

const VIDEO_ID = 'jwFpQHbsKlE';

export default Vue.extend({
  name: 'WarRoomSignUpWidget',
  components: {
    BravadoText,
    WarRoomLandingVideo,
    BravadoTheme,
    PlayIcon,
    WarRoomLogoIcon,
  },
  props: {
    alternative: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      videoId: VIDEO_ID,
    };
  },
  computed: {
    rootClass(): Record<string, boolean> {
      return {
        'war-room-sign-up-widget': true,
        'war-room-sign-up-widget--alternative': this.alternative,
      };
    },
    videoPreviewSrc(): string {
      return require('~/components/partials/war-room/WarRoomLandingVideo/images/video-preview.png');
    },
  },
  methods: {
    handleJoin() {
      this.$analytics.logEvent('war-room__war-room-sign-up-widget__join-the-community-button__click');
      this.$modal.showWithRoute('WAR_ROOM_SIGN_UP_MODAL');
    },
  },
});
